// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_int32 from "rescript/lib/es6/caml_int32.js";

function nowMillisecond(param) {
  return Date.now();
}

function redableMillisecond(ms) {
  var pluralize = function (number) {
    if (number > 1) {
      return "s";
    } else {
      return "";
    }
  };
  var oneDay = 86400000;
  if (ms < 3600000) {
    var minute = ms / 60000 | 0;
    return [
            String(minute),
            "minute" + pluralize(minute)
          ];
  }
  if (ms > oneDay) {
    var day = Caml_int32.div(ms, oneDay);
    return [
            String(day),
            "day" + pluralize(day)
          ];
  }
  var hour = ms / 3600000 | 0;
  return [
          String(hour),
          "hour" + pluralize(hour)
        ];
}

function fromNow(datetimeString) {
  var datetime = new Date(datetimeString);
  var ms = datetime.getTime();
  var diff = (Date.now() | 0) - (ms | 0) | 0;
  var match = redableMillisecond(Math.abs(diff));
  return match[0] + " " + match[1] + " " + "ago";
}

export {
  nowMillisecond ,
  redableMillisecond ,
  fromNow ,
  
}
/* No side effect */
